import { NgView } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { ApiService } from "@app/services/api.service";
import { CrudService } from "@app/services/crud.service";
import { CrudController, ICrudScope } from "@app/views/crud.view";
import { eViewType, IContact, ICustomer } from "@models";
import { icons } from "@tools";

export interface IContactScope extends ICrudScope<IContact> {
    customers: ICustomer[];
}

@NgView({
    token: Token.ContactView,
    inherit: [Token.CrudView]
})
export class ContactController extends CrudController<IContact> {

    constructor(
        public $scope: IContactScope,
        crudService: CrudService,
        model: IContact
    ) {

        super(
            $scope,
            crudService,
            model
        );
        this.drawerService.setHelpUrl("Contacts");

        let viewType = this.$state.current.data.viewType;

        if ($scope.model) {
            crudService.$rootScope.setTitle($scope.model.firstName + " " + $scope.model.lastName);

            this.deleteMsg = loc.msg_deleterecord.format(
                loc.contact_title,
                $scope.model.firstName + " " + $scope.model.lastName
            );
        }

        if (viewType == eViewType.new) {
            crudService.$rootScope.setTitle(loc.create + " " + loc.contact_title);

            $scope.model = {
                idCompany: this.$rootScope.company.id,
                shipToBillingAddress: true
            } as any;
        }

        // customers
        this.$http.get<ICustomer[]>("/api/customers/selections").then(response => $scope.customers = response.data);

        // add drawers
        if ($scope.isEdit || $scope.isNew) {
            let drDelete = this.drawerService.addDrawer(icons.deleter, loc.deleter, $scope.delete, $scope.isEdit);
            let drSave = this.drawerService.addDrawer(icons.save, loc.save, $scope.save);
            let drCancel = this.drawerService.addDrawer(icons.cancel, loc.cancel, $scope.cancel);
        } else {
            let drEdit = this.drawerService.addDrawer(icons.edit, loc.edit, () => {
                this.$state.go("kb.admin.contactEdit", { id: $scope.model.id });
            }, this.$rootScope.user.canModifyCustomers);
            let drDelete = this.drawerService.addDrawer(
                icons.deleter,
                loc.deleter,
                $scope.delete,
                this.$rootScope.user.canModifyCustomers
            );
        }

    }

    public client(api: ApiService) {
        return api.contacts;
    }

    public waitForRefresh() {
        return true;
    }

    public onSuccess() {
        this.$state.go("kb.contacts");
    }
    public onDelete() {
        this.$state.go("kb.contacts");
    }
}
